export default {
  tenant: 'Арендатор',
  tenants: 'Арендаторы',
  tenantsOf: 'Арендаторы {{type}}',
  'tenant.name': 'Название арендатора',
  'tenant.description': 'Дополнительная информация об арендаторе или проекте',
  'tenant.verification': 'Уровень KYB верификации',
  'tenant.kyb.basic': 'Базовый (только email)',
  'tenant.kyb.standard': 'Стандартный (email + телефон)',
  'tenant.kyb.premium': 'Премиум (полная верификация)',
  'tenant.list.title': 'Управление арендаторами',
  'tenant.list.subtitle': 'Эффективное управление арендаторами приложения.',
  'tenant.list.search.placeholder': 'Поиск арендаторов по имени или описанию',
  'tenant.info': 'Информация об арендаторе',
  'tenant.form.title': 'Название арендатора',
  'tenant.form.description': 'Описание арендатора',
  'tenant.form.assignments': 'Назначения',
  'tenant.info.helper':
    'Укажите чёткое название, краткое описание и подходящий тип для определения арендатора',
  'tenant.api': 'Настройки API',
  'tenant.api.helper': 'Настройка API для арендатора',
  'tenant.api.origins': 'Разрешённые origin (CORS)',
  'tenant.api.origins.helper':
    'Полные origin, которым разрешено делать запросы к API. Формат: http(s)://host[:порт] — например https://example.com, http://localhost:5173, https://*.example.com. Оставьте пустым для разрешения всех. Используйте "*" для любого origin (не рекомендуется).',
  'tenant.api.origins.wildcard.warning':
    'Внимание: "*" разрешает запросы с ЛЮБОГО origin. Это отключает CORS-защиту для этого арендатора — используйте только для публичных, нечувствительных данных.',
  'tenant.api.origins.invalid':
    'Некорректные origin: {{values}}. Каждое значение должно быть "*" или начинаться с http:// либо https:// и содержать хост (и, опционально, порт).',
  'tenant.api.limit': 'Лимит запросов в месяц',
  'tenant.api.expiration': 'Дата истечения API ключа',
  'tenant.api.active': 'Активный ключ',
  'tenant.api.active.on': 'Активен',
  'tenant.api.active.off': 'Неактивен',
  'tenant.api.token.info':
    'Создайте гранулярный токен с областью {name} для личного использования API',
  'tenant.api.token.helper': 'Срок действия токена истекает в выбранную дату',
  'tenant.api.name.helper':
    'Уникальное имя для этого арендатора. Может быть видимо владельцам ресурсов или пользователям с токеном.',
  'tenant.api.subscriptions.available': 'Доступные подписки',
  'tenant.api.subscriptions.available.placeholder':
    'Выберите подписки, доступные этому арендатору',
  'tenant.api.generateKey': 'Сгенерировать новый API ключ',
  'tenant.api.handleKey': 'Управление API ключом',
  'tenant.api.keyCreated': 'API ключ успешно создан',
  'tenant.api.keyCopied': 'API ключ скопирован в буфер обмена',
  'tenant.api.keys.title': 'API ключи',
  'tenant.api.keys.delete.confirm':
    'Вы уверены, что хотите удалить этот API ключ?',
  'tenant.api.keys.activate.confirm':
    'Вы уверены, что хотите активировать этот API ключ?',
  'tenant.api.keys.deactivate.confirm':
    'Вы уверены, что хотите деактивировать этот API ключ?',
  'tenant.api.keys.delete.success': 'API ключ успешно удалён',
  'tenant.api.keys.deactivate.success': 'API ключ успешно деактивирован',
  'tenant.api.keys.noKeys': 'API ключи не найдены',
  'tenant.api.keys.usageCount': 'Количество использований',
  'tenant.api.keys.info.attention': 'Внимание!',
  'tenant.api.keys.info.attention.alert':
    'Не делитесь этим ключом с третьими лицами. Если ключ скомпрометирован, немедленно отзовите его в панели управления.',
  'tenant.api.keys.info.attention.helper':
    'Сохраните этот API ключ. Он больше не будет показан в системе.',
};
